var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1795_32007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50033 10.0846C8.03163 10.0846 10.0837 8.03261 10.0837 5.5013C10.0837 2.97 8.03163 0.917969 5.50033 0.917969C2.96902 0.917969 0.916992 2.97 0.916992 5.5013C0.916992 8.03261 2.96902 10.0846 5.50033 10.0846Z",
    stroke: "currentColor",
    strokeWidth: 0.916667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.75V5.5L7.33333 6.41667",
    stroke: "currentColor",
    strokeWidth: 0.916667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1795_32007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.a212d520a1fe2ad9d9c11bfaf96db9c5.svg";
export { ForwardRef as ReactComponent };